export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_growcalc-privacy/artifacts/aa1ptkib_GrowCalc.png";

export const CONTACT_EMAIL = "GrowCalcs@gmail.com";

export const TOS_EFFECTIVE_DATE = "June 15, 2026";

export const tosIntro =
  "These Terms of Service (\u201cTerms\u201d) govern your use of the GrowCalc mobile application (the \u201cApp\u201d) provided by GrowCalc (\u201cwe\u201d, \u201cus\u201d). By downloading or using the App, you agree to these Terms.";

export const tosSections = [
  {
    id: "the-service",
    title: "1. The Service",
    paragraph:
      "GrowCalc is a lawn-care and fertilizer calculator that helps you compute application rates, track products and applications, monitor soil pH and weather, and plan treatments.",
  },
  {
    id: "accounts",
    title: "2. Accounts",
    paragraph:
      "You are responsible for the accuracy of the information you provide and for keeping your account credentials secure. You must be at least 13 years old to use the App.",
  },
  {
    id: "subscriptions-billing",
    title: "3. Subscriptions & Billing",
    items: [
      { text: "\u201cGrowCalc Pro\u201d is offered as an auto-renewing subscription, which may include a free trial." },
      { text: "Payment is charged to your Apple App Store or Google Play account. Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current period." },
      { text: "You manage or cancel your subscription through your app store account settings. We do not process or store your payment details." },
    ],
  },
  {
    id: "acceptable-use",
    title: "4. Acceptable Use",
    paragraph:
      "You agree not to misuse the App, including attempting to disrupt it, reverse-engineer it, or use it for unlawful purposes.",
  },
  {
    id: "disclaimer",
    title: "5. Important Disclaimer",
    paragraph:
      "GrowCalc provides calculations, estimates, and general guidance FOR INFORMATIONAL PURPOSES ONLY. It is not professional agronomic, horticultural, environmental, or legal advice. ALWAYS read and follow the product label and local regulations before applying any fertilizer, pesticide, herbicide, fungicide, or other product. You are solely responsible for how you apply products and for compliance with applicable laws. Use the App at your own risk.",
  },
  {
    id: "liability",
    title: "6. Limitation of Liability",
    paragraph:
      "To the maximum extent permitted by law, the App is provided \u201cas is\u201d without warranties of any kind, and we are not liable for any indirect, incidental, or consequential damages, or for any loss arising from your use of the App or reliance on its calculations.",
  },
  {
    id: "intellectual-property",
    title: "7. Intellectual Property",
    paragraph:
      "The App, including its design, content, and trademarks, is owned by GrowCalc. The data you enter remains yours.",
  },
  {
    id: "termination",
    title: "8. Termination",
    paragraph:
      "You may stop using the App at any time and delete your account. We may suspend or terminate access if these Terms are violated.",
  },
  {
    id: "changes",
    title: "9. Changes to These Terms",
    paragraph:
      "We may update these Terms from time to time. Continued use of the App after changes take effect constitutes acceptance of the updated Terms.",
  },
  {
    id: "governing-law",
    title: "10. Governing Law",
    paragraph:
      "These Terms are governed by the laws applicable in the jurisdiction in which the developer operates, without regard to conflict-of-law principles.",
  },
];
